import React, { useState, useEffect } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import exportingInit from 'highcharts/modules/exporting';
import exportDataInit from 'highcharts/modules/export-data';
import HighchartsMore from 'highcharts/highcharts-more';

// Initialize the exporting and export data modules
exportingInit(Highcharts);
exportDataInit(Highcharts);
HighchartsMore(Highcharts);

const FlexibilityChartWeekly = ({ chartData }) => {
  const [chartOptions, setChartOptions] = useState(null);

  useEffect(() => {
    if (!chartData) return;

    // Flatten the data into a single array
    const consumptionRanges = [];
    const consumptionAverages = [];
    const productionRanges = [];
    const productionAverages = [];

    chartData.forEach(day => {
      const date = new Date(day.date);
      day.hourly_stats.forEach(hourStat => {
        const time = new Date(date);
        time.setHours(hourStat.hour);

        consumptionRanges.push([time.getTime(), hourStat.flexibility_down_consumption, hourStat.flexibility_up_consumption]);
        consumptionAverages.push([time.getTime(), hourStat.baseline_consumption]);
        productionRanges.push([time.getTime(), hourStat.flexibility_down_production, hourStat.flexibility_up_production]);
        productionAverages.push([time.getTime(), hourStat.baseline_production]);
      });
    });

    const consumptionColor = Highcharts.getOptions().colors[0];
    const productionColor = Highcharts.getOptions().colors[1];

    setChartOptions({
      chart: {
        zoomType: 'x'
      },
      title: {
        text: null
      },
      xAxis: {
        type: 'datetime',
        title: {
          text: 'Date'
        },
        dateTimeLabelFormats: {
          day: '%e %b' // Format the date like '1 Jan'
        },
        tickInterval: 24 * 3600 * 1000, // 1 day intervals
      },
      yAxis: {
        gridLineWidth: 0,
        title: {
          text: 'Consumption/Production (kWh)'
        }
      },
      tooltip: {
        crosshairs: true,
        shared: true,
        valueSuffix: ' kWh'
      },
      plotOptions: {
        series: {
          pointInterval: 3600 * 1000, // 1 hour intervals
        }
      },
      series: [
        {
          name: 'Consumption',
          type: 'line',
          data: consumptionAverages,
          zIndex: 1,
          marker: {
            fillColor: 'white',
            lineWidth: 2,
            lineColor: consumptionColor
          }
        },
        {
          name: 'Flexibility Consumption Range',
          data: consumptionRanges,
          type: 'arearange',
          lineWidth: 0,
          linkedTo: ':previous',
          color: consumptionColor,
          fillOpacity: 0.3,
          zIndex: 0,
          marker: {
            enabled: false
          }
        },
        {
          name: 'Production',
          type: 'line',
          data: productionAverages,
          zIndex: 1,
          marker: {
            fillColor: 'white',
            lineWidth: 2,
            lineColor: productionColor
          }
        },
        {
          name: 'Flexibility Production Range',
          data: productionRanges,
          type: 'arearange',
          lineWidth: 0,
          linkedTo: ':previous',
          color: productionColor,
          fillOpacity: 0.3,
          zIndex: 0,
          marker: {
            enabled: false
          }
        }
      ],
      exporting: {
        enabled: true
      },
      credits: {
        enabled: false
      },
      accessibility: {
        enabled: false
      }
    });
  }, [chartData]);

  if (!chartOptions || !chartData) return null;

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={chartOptions}
      containerProps={{ style: { height: '100%', width: '100%' } }}
    />
  );

};

export default FlexibilityChartWeekly;
